import TextCell from 'components/TextCell';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function AssetsEnabledCell({
  rowData: { totalAssetsEnabled },
}: CellProps) {
  return <TextCell text={String(totalAssetsEnabled)} />;
}
